import { optionTitle_roomPreferencesOption } from './RoomPreferences.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';

const lazyFullModule = new LazyModule(() => import('./lazyRoomPreferencesOption'));

const RoomPreferencesOption: LazyOption = createLazyOption(
    {
        key: 'roomPreferenceOption',
        titleStringKey: optionTitle_roomPreferencesOption,
        searchTermsStringKey: optionTitle_roomPreferencesOption,
        isHidden: () => {
            return !isFeatureEnabled('cal-mf-room-preferences');
        },
    },
    lazyFullModule,
    m => m.default
);

export default RoomPreferencesOption;
